/*
 * 主机地址配置
*/
let Host_url = {
	visturl:'', //访问地址
	apiurl:'',  //请求地址
	otheurl:''  //其他
}
// 环境的切换
if (process.env.NODE_ENV == 'development') {
   Host_url.visturl= 'http://pro.cooco.net.cn';
   Host_url.apiurl =  'http://php.cooco.net.cn';
   Host_url.otheurl = 'http://pro.cooco.net.cn';
} else if (process.env.NODE_ENV == 'debug') {
   Host_url.visturl= 'http://pro.cooco.net.cn';
   Host_url.apiurl =  'http://php.cooco.net.cn';
   Host_url.otheurl = 'http://pro.cooco.net.cn';
} else if (process.env.NODE_ENV == 'production') {
   Host_url.visturl= 'http://pro.cooco.net.cn';
   Host_url.apiurl =  'http://php.cooco.net.cn';
   Host_url.otheurl = 'http://pro.cooco.net.cn';
};
export default{
	...Host_url
}


// WEBPACK FOOTER //
// ./src/common/config.js